<section>
  <div class="modal-main-wrapper">
    <div class="modal-close" (click)="onNoClick()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          d="M11 1.375C5.6375 1.375 1.375 5.6375 1.375 11C1.375 16.3625 5.6375 20.625 11 20.625C16.3625 20.625 20.625 16.3625 20.625 11C20.625 5.6375 16.3625 1.375 11 1.375ZM14.7125 15.8125L11 12.1L7.2875 15.8125L6.1875 14.7125L9.9 11L6.1875 7.2875L7.2875 6.1875L11 9.9L14.7125 6.1875L15.8125 7.2875L12.1 11L15.8125 14.7125L14.7125 15.8125Z"
          fill="#2708C5"
        />
      </svg>
    </div>

    <div class="header">
      <h2>timeline</h2>
    </div>

    <div class="timelineWrapper">
      <ul>
        <li *ngFor="let timelineData of taskTimelineData">
          <h3>{{timelineData?.actionType}} - {{timelineData?.actorData?.firstName + " " + timelineData?.actorData?.lastName}}</h3>
          <h4>Task Name: {{timelineData?.assignmentData?.serviceTaskData?.taskData?.taskName + " - " + timelineData?.assignmentData?.serviceTaskData?.taskData?.taskCode}}</h4>
          <p>
           {{timelineData?.message}}
          </p>
          <h6>{{timelineData?.createdAt | date:'MMMM d YYYY, h:mm a'}}</h6>
        </li>
        </ul>
    </div>
  </div>
</section>
